module.exports = __webpack_public_path__ + "img/profile.8c1e594c.jpg";